/**
 * venueData.js
 * Central source of truth for all Beejees Convention Centre facts.
 * Edit values here — every page pulls from this file, so a correction
 * only needs to be made once.
 *
 * NOTE: Figures marked "approximate" are sourced from public listings
 * and should be confirmed with the venue before publishing live.
 */

const venueData = {
  name: "Beejees Convention Centre",
  tagline: "Where Palakkad Comes Together",
  supportingLine:
    "A versatile setting for weddings, celebrations, conferences and meaningful gatherings.",

  address: {
    line1: "Poodur, Kodumthirapully, Po ",
    line2: "Near Poodur Bridge, Koduntharapully",
    city: "Palakkad, ",
    state: "Kerala",
    pincode: "678004",
    full: "Near Poodur Bridge, Poodur, Pirayiri, Palakkad, Kerala – 678004",
    mapsQuery:
      "Beejees Convention Centre, Near Poodur Bridge, Poodur, Pirayiri, Palakkad, Kerala 678004",
  },

  contact: {
    phonePrimary: "+91 00000 00000", // placeholder — replace with verified number
    whatsapp: "+91 00000 00000", // placeholder — replace with verified WhatsApp number
    email: "info@beejeesconvention.com", // placeholder
    hours:
      "Open daily · 9:00 AM – 7:00 PM (placeholder, confirm before publishing)",
  },

  capacity: {
    seated: 600,
    seatedLabel: "Seated guests",
    floating: 700,
    floatingLabel: "Floating capacity",
    note: "Approximate capacity — subject to layout, catering style and event configuration.",
  },

  parking: {
    cars: 100,
    bikes: 200,
    note: "Approximate on-site parking availability.",
  },

  rooms: {
    total: 2,
    acRooms: 2,
    bridalRoom: 1,
    note: "Two rooms available, both air-conditioned, including a dedicated bridal room.",
  },

  facilities: [
    "Electricity backup",
    "Two air-conditioned rooms",
    "Dedicated bridal room",
    "Vegetarian and non-vegetarian dining possibilities",
    "On-site parking for cars and two-wheelers",
    "External catering or decoration — subject to venue approval",
  ],

  diningNote:
    "Both vegetarian and non-vegetarian dining are possible at the venue. External catering and decoration teams may be permitted, subject to prior approval from Beejees management.",

  policyNote:
    "Pricing, exact policies and availability are confirmed directly with our events team and may vary by date and event type. Details on this website are indicative and subject to confirmation.",

  glanceStats: [
    { value: 600, suffix: "", label: "Seated guests" },
    { value: 700, suffix: "", label: "Floating capacity" },
    { value: 100, suffix: "", label: "Car parking" },
    { value: 200, suffix: "", label: "Bike parking" },
    { value: 2, suffix: "", label: "A/C rooms" },
    { value: 1, suffix: "", label: "Bridal room" },
  ],

  social: {
    instagram: "#",
    facebook: "#",
    whatsapp: "#",
  },
};

export default venueData;
